var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyNotifications({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3181 25.2056H39.4753V28.7957H17.3181V25.2056Z",
    fill: "#BFBFBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3181 33.9028H39.4753V37.4926H17.3181V33.9028Z",
    fill: "#BFBFBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4975 17.3196C63.4975 10.9344 58.3029 5.7395 51.9178 5.7395C47.2285 5.7395 43.1807 8.54126 41.362 12.5587H9.29175C5.34658 12.5587 2.1366 15.7691 2.1366 19.7139V42.6886C2.1366 46.6342 5.34658 49.8445 9.29175 49.8445H11.228V60.1213L26.578 49.8445H46.5626C50.5085 49.8445 53.7185 46.6342 53.7185 42.6886V28.7592C59.2508 27.8914 63.4975 23.092 63.4975 17.3196ZM46.5626 46.254H25.4874L14.8177 53.3972V46.254H9.29175C7.32591 46.254 5.72634 44.6548 5.72634 42.6886V19.7139C5.72634 17.7484 7.32591 16.1492 9.29175 16.1492H40.3969C40.3579 16.5338 40.3377 16.9245 40.3377 17.3196C40.3377 23.0957 44.5896 27.8982 50.128 28.7611V42.6886C50.128 44.6548 48.5284 46.254 46.5626 46.254ZM51.9178 25.3091C47.5123 25.3091 43.9282 21.725 43.9282 17.3196C43.9282 12.9138 47.5123 9.32925 51.9178 9.32925C56.3232 9.32925 59.9077 12.9138 59.9077 17.3196C59.9077 21.725 56.3232 25.3091 51.9178 25.3091Z",
    fill: "#BFBFBF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1233 13.0701H53.7134V21.5664H50.1233V13.0701Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNotifications);
export default __webpack_public_path__ + "static/media/empty-notifications.739e2e10.svg";
export { ForwardRef as ReactComponent };